//React
import { FunctionComponent, useEffect, useState } from "react";

//Selectors
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";
import { selectAreaInfo } from "../../../area-info/redux/selectors/select-area-info";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { DrhLink } from "../../../system/models/drh-link";

const _ = require("lodash");

const BreadCrumb: FunctionComponent = (props) => {
	//State Values
	const areaInfo = useAppSelector(selectAreaInfo);

	//Use States
	const [breadCrumbLinks, setBreadCrumbLinks] = useState<DrhLink[]>([]);
	const [showBreadCrumb, setShowBreadCrumb] = useState(false);

	useEffect(() => {
		if (isStringEmpty(areaInfo?.Url)) {
			return;
		}
		let urlParts = areaInfo?.Url.split("/");
		let crumbParts = areaInfo?.Breadcrumb.split("/");
		let links = [];
		links.push({ url: "/", title: "Home" });
		for (let index = 0; index < urlParts.length; index++) {
			const urlPart = urlParts[index];
			const crumbPart = crumbParts[index];
			if (!isStringEmpty(urlPart)) {
				let title = crumbPart;
				let url = "";
				let sep = "";
				for (let index2 = 0; index2 <= index; index2++) {
					url += sep + urlParts[index2];
					sep = "/";
				}
				links.push({ url: url, title: title });
			}
		}
		setBreadCrumbLinks(links);
		setShowBreadCrumb(true);
	}, [areaInfo]);

	//JSX
	if (!showBreadCrumb) {
		return null;
	}

	if (isStringEmpty(areaInfo?.Url)) {
		return null;
	}

	return (
		<nav className="breadcrumbs locationpage">
			<ul>
				{breadCrumbLinks.map((link, index) =>
					index === breadCrumbLinks.length - 1 ? (
						<li key={link.toString() + index}>{link.title}</li>
					) : (
						<li key={link.toString() + index}>
							<a href={link.url}>{link.title}</a>
						</li>
					),
				)}
			</ul>
		</nav>
	);
};

export default BreadCrumb;
